import {UsuarioModel} from "@/models/seguridad/usuario";
import UsuarioAPI from "@/services/seguridad/usuario";
import {EventBus} from '@/events/event-bus';
import * as events from '@/constants/event-names';
import * as R from "ramda";
import {scrollToForm} from '@/helpers/form-scroll-to';
import {getErrors,getBusinessCode,getResponseDTO} from '@/helpers/http-response-handler';

function evaluateModelChangedFlag(data){
  if(!data && typeof data === "boolean"){
  return data
  }

  if(data && typeof data === "object"){
  return data.length>=1;
  } 
}
const modelIsModified = R.curry((mod)=>R.compose(evaluateModelChangedFlag,mod.changed)());

//Base State
function BaseStateForm(){}
// States' consctructors
export function InitialState(self){
  //Assing context
  this.data = self;
  //Reset Models and validators
  this.resetModel();
  this.resetValidators();
  //View configuration
  this.data.view.elem.button.resetpassword.visible=false;
  this.data.view.elem.button.clear.visible=true;
  this.data.view.elem.button.audit.visible=false;
  this.data.view.elem.input.username.visible=true;
  this.data.view.elem.input.username.disabled=false;
  this.data.view.elem.button.submit.class.current = this.data.view.elem.button.submit.class.save;
  this.data.view.elem.button.submit.data.title.current = this.data.view.elem.button.submit.data.title.save;

  this.data.view.elem.button.enabled.visible = false;
  
  try{
    this.data.$refs.uploadImage.imgDataUrl =  "/static/img/user_thumbnail.jpg";
  } catch(err){
  }
}


export function EditingState(self, usuario){
  let {username
    , nombre
    , telefono
    , interno
    , celular
    , correoElectronico
    , comercio
    , enabled, activo
    , foto
    , foto_miniatura} = usuario;
  
  this.data = self;
  
  let arrayValues = [];
  

  this.data.usuario = new UsuarioModel({ username
    , nombre
    , telefono
    , interno
    , celular
    , correoElectronico
    , comercio
    , enabled, activo
    , foto:foto_miniatura
    , foto_miniatura});
  this.data.view.elem.button.resetpassword.visible=true;
  this.data.view.elem.button.clear.visible=true;
  this.data.view.elem.button.audit.visible=true;
  this.data.view.elem.input.username.visible=true;
  this.data.view.elem.input.username.disabled=true;
  this.data.view.elem.button.submit.class.current = this.data.view.elem.button.submit.class.update;
  this.data.view.elem.button.submit.data.title.current = this.data.view.elem.button.submit.data.title.update;

  this.data.view.elem.button.enabled.visible = true;
  this.data.view.elem.button.enabled.class.current = activo ? this.data.view.elem.button.enabled.class.disabled : this.data.view.elem.button.enabled.class.enabled;
  this.data.view.elem.button.enabled.data.title.current = activo ? this.data.view.elem.button.enabled.data.title.disabled :this.data.view.elem.button.enabled.data.title.enabled;
 
  this.resetValidators();
}
export function SavedState(self, {username
  , nombre
  , telefono
  , interno
  , celular
  , correoElectronico
  , comercio	
  , enabled, activo
  , foto
  , foto_miniatura}){}
// Setting Base as prototype
InitialState.prototype = Object.create(BaseStateForm.prototype);
EditingState.prototype = Object.create(BaseStateForm.prototype);
SavedState.prototype   = Object.create(BaseStateForm.prototype);
// Setting his own constructor instead of constructor's prototype
InitialState.prototype.constructor = InitialState;
EditingState.prototype.constructor = EditingState;
SavedState.prototype.constructor   = SavedState;
//Base skeleton
BaseStateForm.prototype.save   = function(){console.log("save no implementado"); return Promise.resolve()}
BaseStateForm.prototype.edit   = function(){console.log("edit no implementado"); return Promise.resolve()}
BaseStateForm.prototype.submit = function(){console.log("submit no implementado"); return Promise.resolve()}
BaseStateForm.prototype.askForClear = async function(){
  try{
    const response = await this.data.$swal({
      title: this.data.$t('view.global.swal.clear.title')
      , text: this.data.$t('view.global.swal.clear.text')
      , type: this.data.$t('view.global.swal.clear.type')
      , showCancelButton: this.data.$t('view.global.swal.clear.showCancelButton')
      , confirmButtonColor: this.data.$t('view.global.swal.clear.confirmButtonColor')
      , cancelButtonColor: this.data.$t('view.global.swal.clear.cancelButtonColor')
      , confirmButtonText: this.data.$t('view.global.swal.clear.confirmButtonText')
      , cancelButtonText: this.data.$t('view.global.swal.clear.cancelButtonText')
      , reverseButtons: true
    });
    if(response.value){
      this.data.state.clear();
    }
    return;
  }catch(error){
    console.log(error)
  }
};
BaseStateForm.prototype.askForResetPassword = async function(username){
  try{
    const response = await this.data.$swal({
      title: this.data.$t('view.global.swal.resetPassword.title')
      , text: this.data.$t('view.global.swal.resetPassword.text')
      , type: this.data.$t('view.global.swal.resetPassword.type')
      , showCancelButton: this.data.$t('view.global.swal.clear.showCancelButton')
      , confirmButtonColor: this.data.$t('view.global.swal.clear.confirmButtonColor')
      , cancelButtonColor: this.data.$t('view.global.swal.clear.cancelButtonColor')
      , confirmButtonText: this.data.$t('view.global.swal.clear.confirmButtonText')
      , cancelButtonText: this.data.$t('view.global.swal.clear.cancelButtonText')
      , reverseButtons: true
    });
    if(response.value){
      const respuesta = await UsuarioAPI.resetPassword(username);

      if(respuesta && respuesta.status==200)
      {
        if(((respuesta.data || {}).meta || {}).code == "OK" )
        {
          EventBus.$emit(events.MESSAGES, {type:((respuesta.data || {}).meta || {}).code});
        } 
        else if(((respuesta.data || {}).meta || {}).code || 'ERROR')
        {
          let {data:{meta:{code}}} = respuesta;
          EventBus.$emit(events.MESSAGES, {type:'error',message: getErrors('Usuarios','Mensaje Default',((respuesta.data || {}).meta || {}).code)});
        }
      }
    }
    return;
  }catch(error){
    console.log(error)
  }
};
BaseStateForm.prototype.clear = function(){Object.setPrototypeOf(this.data.state, new InitialState(this.data));}
BaseStateForm.prototype.resetModel = function(){this.data.usuario = new UsuarioModel();}
BaseStateForm.prototype.resetValidators = function(){this.data.$v.$reset();}
BaseStateForm.prototype.isDisableButtonSubmit = function(){return this.data.hasErrors(this.data.$v.usuario)|| this.data.view.action.submit.busy}


//Initial State Implementation
InitialState.prototype.submit = async function({username
  , nombre
  , telefono
  , interno
  , celular
  , correoElectronico
  , comercio
  , enabled, activo
  , foto}){
  try{
    if(!this.data.isAllValid(this.data.$v)){
      scrollToForm(this.data);
      return false;
    }
    
    if(comercio.length > 0){
      const filter = comercio.map(valueItems => {
        return valueItems.code;
      });
      comercio = filter.toString();
    }else{
      comercio = null;
    }
    
    let usuario = {username
      , nombre
      , telefono
      , interno
      , celular
      , correoElectronico
      , comercio
      , enabled, activo
      , foto}

    this.data.view.action.submit.busy=true;
    const response = await UsuarioAPI.save(usuario);
    this.data.view.action.submit.busy=false;
    this.resetModel();
    this.resetValidators();
  
    this.data.$refs.usuarioTable.refreshData();
    return response;
  }catch(error){
    console.log(error)
    return error;
  }
}
//Editing State Implementation
EditingState.prototype.submit = async function(usuario){
  let {username
    , nombre
    , telefono
    , interno
    , celular
    , correoElectronico
    , comercio
    , enabled, activo
    , foto
    , foto_miniatura}=usuario;
  try{
    if(!this.data.isAllValid(this.data.$v)){
      scrollToForm(this.data);
      return false;
    }

    if(comercio.length > 0){
      const filter = comercio.map(valueItems => {
        return valueItems.code;
      });
      comercio = filter.toString();
    }else{
      comercio = null;
    }
    
    this.data.view.action.submit.busy=true;
    const response = await UsuarioAPI.update({username
      , nombre
      , telefono
      , interno
      , celular
      , correoElectronico
      , comercio
      , enabled, activo
      , foto
      , foto_miniatura});
    this.data.view.action.submit.busy=false;
    Object.setPrototypeOf(this.data.state, new InitialState(this.data));
    this.data.$refs.usuarioTable.refreshData();
    return response;
  }catch(error){
    console.log(error)
    return error;
  }
  console.log("actualizando datos existentes")
}
EditingState.prototype.isDisableButtonSubmit = function(){
  
  return this.data.hasErrors(this.data.$v.usuario) 
    || this.data.view.action.submit.busy
    || !modelIsModified(this.data.usuario)
}

//Saved State Implementation




// WEBPACK FOOTER //
// ./src/views/seguridad/usuario/usuario-states.js